import { render, staticRenderFns } from "./focus.vue?vue&type=template&id=6b0e2920&scoped=true&"
import script from "./focus.vue?vue&type=script&lang=js&"
export * from "./focus.vue?vue&type=script&lang=js&"
import style0 from "./focus.vue?vue&type=style&index=0&id=6b0e2920&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0e2920",
  null
  
)

export default component.exports